export default __webpack_public_path__ + "static/media/AT002.9de1fbc7.mp3";